import Vue from 'vue'
import { Validator } from 'vee-validate'

Validator.extend('password', {
  getMessage: () => 'Password must contains a lowercase letter, an uppercase letter, a number, and be at least 8 characters.',
  validate: value => /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/.test(value)
})

Validator.localize('en', {
  custom: {
    password_confirmation: {
      is: 'The password confirmation does not match.'
    }
  }
})

Vue.mixin({
  methods: {
    validationClasses (name, scope) {
      return [this.errorClass(name, scope), this.validClass(name, scope)]
    },

    errorClass (name, scope) {
      let field = this.$validator.fields.find({ name, scope })

      if (field) {
        return field.flags.invalid && field.flags.validated ? 'is-invalid' : ''
      }
    },

    validClass (name, scope) {
      let field = this.$validator.fields.find({ name, scope })

      if (field) {
        return field.flags.valid && field.flags.validated ? 'is-valid' : ''
      }
    }
  }
})
